import SmallCross from "../../../assets/icons/SmallCross";

/**
 * A single error message
 * with a clear button to
 * clear errors
 */
const ErrorMessage = ({
  message,
  className,
  clearError
}: {
  message: string;
  className?: string;
  clearError: () => void;
}) => (
  <article
    className={
      "flex w-full items-center justify-between rounded border-[1px] border-red-400 bg-red-100 px-3 py-2 " +
      className
    }
  >
    <p className="text-sm text-ctb-red-500">{message}</p>
    <button onClick={() => clearError()}>
      <SmallCross className="fill-red-500" />
    </button>
  </article>
);

export default ErrorMessage;
